import angular from 'angular';
import gridHeight from '../../core/shared-service/grid-utils';

class PrincipalGroupCtrl {
  /*@ngInject*/
  constructor(PrincipalSvc, $state, logger, $uibModal) {
    this.PrincipalSvc = PrincipalSvc;
    this.$state = $state;
    this.logger = logger;
    this.$uibModal = $uibModal;
  }

  $onInit() {
    this.includes = {
      headerTemplate: require('../principal-header-info.html'),
      errorMessages: require('../../layouts/error-messages.html')
    };
    var ctrl = this;

    var countryCellTemplate =
      '<div class="ui-grid-cell-contents">{{"country." + COL_FIELD | lowercase | translate}}</div>';
    var deleteCellTemplate =
      '<div class="ui-grid-cell-contents text-center pointer"' +
      'ng-click="grid.appScope.$ctrl.deleteCompany(row.entity)"><span><i class="fa fa-trash"></i></span>&nbsp;</div>';

    // Gestion de la grille
    this.gridOptions = {
      columnDefs: [
        { name: 'name', displayName: 'Raison Sociale', sort: { direction: 'asc', priority: 0 } },
        { name: 'idFiscal', displayName: 'ID Fiscal' },
        { name: 'idNational', displayName: 'ID Légal' },
        { name: 'countryCode', displayName: 'Pays', cellTemplate: countryCellTemplate },
        { name: 'delete', displayName: '', width: '50', cellTemplate: deleteCellTemplate, enableSorting: false }
      ],
      paginationPageSize: 10,
      paginationPageSizes: [10, 50],
      enableSorting: true,
      enableGridMenu: false,
      enableColumnMenus: false,
      onRegisterApi: function(gridApi) {
        ctrl.gridApi = gridApi;
      }
    };
    this.initCriteria();
  }

  /**
   * initialise le tableau avec les sociétés.
   */
  initCriteria() {
    if (!this.creation) {
      this.gridOptions.data = this.group.companies;
      this.criteria = {};
      this.criteria.name = this.group.name;
      this.criteria.description = this.group.description;
    }
  }

  save() {
    if (this.form.$valid) {
      if (this.gridOptions.data.length === 0) {
        this.logger.error('principal.group.creation.group_one_company_min');
        return;
      }

      this.criteria.legalEntityIds = this.gridOptions.data.map(company => company.id);
      var promise = this.creation
        ? this.PrincipalSvc.createGroup(this.principal.detail.id, this.criteria)
        : this.PrincipalSvc.updateGroup(this.principal.detail.id, this.group.id, this.criteria);
      promise.then(
        () => {
          var msg = this.creation ? 'principal.group.creation_success' : 'principal.group.update_success';
          this.logger.success(msg);
          this.$state.go('app.principal.consult.group');
        },
        error => {
          if (error.status === 400 && error.data) {
            if (error.data.code === 'GROUP_NAME_ALREADY_EXISTS') {
              this.logger.error('error.functional.group_name_already_exists');
            }
          } else {
            var msg = this.creation ? 'error.create' : 'error.update';
            this.logger.error(msg);
          }
        },
        () => {
          this.criteria.companies = [];
        }
      );
    }
  }

  /**
   * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
   */
  getGridHeight() {
    return gridHeight(this.gridApi);
  }

  openModalCompanies() {
    var ctrl = this;
    this.$uibModal
      .open({
        component: 'modal-group-add-companies',
        size: 'lg',
        resolve: {
          companies: function() {
            return ctrl.companies;
          },
          currentCompanies: function() {
            return ctrl.gridOptions.data;
          }
        }
      })
      .result.then(
        function(companies) {
          ctrl.gridOptions.data = ctrl.gridOptions.data.concat(companies);
          ctrl.gridOptions.totalItems = ctrl.gridOptions.data.length;
        },
        function() {}
      );
  }

  deleteCompany(company) {
    var index = this.gridOptions.data.indexOf(company);
    this.gridOptions.data.splice(index, 1);
    this.gridOptions.totalItems = this.gridOptions.data.length;
  }
}

angular.module('app.principal').component('principalGroupDetail', {
  templateUrl: require('./principal-group-detail.html'),
  controller: PrincipalGroupCtrl,
  bindings: {
    principal: '<',
    companies: '<',
    creation: '<',
    group: '<'
  }
});
